<template>
  <div class="login-container">
    <van-loading v-if="loading" size="24px" vertical>登录中...</van-loading>
  </div>
</template>

<script>
import DingtalkService from '@/api/dingtalk/DingtalkService.js'
import Vue from "vue";

export default {
  data() {
    return {
      loading: false,
      loginTimer: null,
      isReloading: false,
      hasReloaded: false
    }
  },
  mounted() {
    this.reloadDingtalkEnvironment()
  },
  beforeDestroy() {
    if (this.loginTimer) {
      clearTimeout(this.loginTimer)
    }
  },
  methods: {
    reloadDingtalkEnvironment() {
      const reloadKey = 'dingtalk_login_reloaded_' + this.getQueryVariable('corpId')
      const hasReloaded = localStorage.getItem(reloadKey)

      if (hasReloaded) {
        localStorage.removeItem(reloadKey)
        this.executeLogin()
        return
      }

      this.loading = true
      localStorage.setItem(reloadKey, 'true')
      window.location.reload()
    },
    executeLogin() {
      if (this.isReloading) {
        return
      }

      this.loading = true

      Vue.cookie.delete('token')
      Vue.cookie.delete('pm-token')
      // Vue.cookie.delete('date');
      Vue.cookie.delete('name');
      Vue.cookie.delete('userId');
      Vue.cookie.delete('sjplsp')
      Vue.cookie.delete('searchValue')
      Vue.cookie.delete('searchTitle')
      Vue.cookie.delete('searchTitleId')
      Vue.cookie.delete('todoSearchValue')
      Vue.cookie.delete('doneSearchValue')
      Vue.cookie.delete('sponsorSearchValue')
      localStorage.removeItem('current')
      localStorage.removeItem('scrollTopPosition')
      localStorage.removeItem('size')
      localStorage.removeItem('SponsorCurrent')
      localStorage.removeItem('scrollSponsorPosition')
      localStorage.removeItem('SponsorSize')
      localStorage.removeItem('DoneCurrent')
      localStorage.removeItem('scrollDonePosition')
      localStorage.removeItem('DoneSize')
      localStorage.removeItem('tabbarName')
      localStorage.removeItem('category')
      localStorage.removeItem('businessTable')
      localStorage.removeItem('businessName')

      let corpId = this.getQueryVariable('corpId')
      let loginSuccess = false

      const loginTimeout = setTimeout(() => {
        if (!loginSuccess && !this.isReloading) {
          this.isReloading = true
          this.loading = false
          this.$toast.fail('登录超时，请手动刷新页面重试')
        }
      }, 10000)

      this.loginTimer = loginTimeout

      const requestAuthCode = (corpId) => {
        return new Promise((resolve, reject) => {
          dd.runtime.permission.requestAuthCode({
            corpId: corpId,
            onSuccess: (result) => resolve(result.code),
            onFail: (err) => reject(err)
          })
        })
      }

      const loginPmFallback = () => {
        const service = new DingtalkService()
        return service.getLoginCode('2').then(res => {
          return service.codeLogin(res.data.mobile, res.data.loginCode).then(res2 => {
            Vue.cookie.set('pm-token', res2.data.token)
            Vue.cookie.set('mater-userId', res2.data.userId)
          })
        })
      }

      const doLogin = () => {
        requestAuthCode(corpId).then((code) => {
          return new DingtalkService().dingtalkLogin(code, corpId)
        }).then(({ data }) => {
          if (data.code !== 200) {
            this.$toast.fail(data.message)
            return
          }
          Vue.cookie.set('token', data.token)
          Vue.cookie.set('name', data.name)
          Vue.cookie.set('userId', data.userId)
          Vue.cookie.set('sjplsp', data.sjplsp)
          loginSuccess = true
          clearTimeout(loginTimeout)
          this.loading = false
          this.$router.replace('/flowable/index')

          requestAuthCode(corpId).then((pmCode) => {
            return new DingtalkService().materDingtalkLogin(pmCode).then(({ data }) => {
              if(data.code === 200) {
                Vue.cookie.set('pm-token', data.token)
                Vue.cookie.set('mater-userId', data.userId)
              } else {
                loginPmFallback()
              }
            })
          }).catch(() => {
            return loginPmFallback()
          })
        }).catch((err) => {
          this.$message.error('err:' + JSON.stringify(err))
        })
      }

      if (dd.version) {
        doLogin()
      } else {
        dd.ready(() => {
          doLogin()
        })
        dd.error((err) => {
          clearTimeout(loginTimeout)
          this.loading = false
          this.$toast.fail('钉钉环境初始化失败，请手动刷新页面重试')
        })
      }
    },
    reloadPage() {
      window.location.reload()
    },
    getQueryVariable(variable) {
      var query = window.location.href.split("?")[1]
      if (!query) return false
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return (false);
    }
  }
}
</script>

<style>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}
</style>
